var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotImportant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6094 26.0625L4.6875 6.14062C2.34375 8.66016 0.9375 12.0586 0.9375 15.75C0.9375 23.543 7.20703 29.8125 15 29.8125C18.6914 29.8125 22.0898 28.4062 24.6094 26.0625ZM25.2539 25.3594C27.5977 22.8984 29.0625 19.5 29.0625 15.75C29.0625 8.01562 22.7344 1.6875 15 1.6875C11.25 1.6875 7.85156 3.15234 5.39062 5.49609L25.2539 25.3594ZM0 15.75C0 10.418 2.8125 5.49609 7.5 2.80078C12.1289 0.105469 17.8125 0.105469 22.5 2.80078C27.1289 5.49609 30 10.418 30 15.75C30 21.1406 27.1289 26.0625 22.5 28.7578C17.8125 31.4531 12.1289 31.4531 7.5 28.7578C2.8125 26.0625 0 21.1406 0 15.75Z",
    fill: "#0D63CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotImportant);
export default __webpack_public_path__ + "static/media/icon_not_important.6bb8610a246dd9f09b0f048d3784836e.svg";
export { ForwardRef as ReactComponent };